<template>
  <div class="result-profil">
    <img class="result-badge-logo" alt="" src="/images/results/badge_pilot.svg" />
    <b class="result-profil-title">{{ $t('candidate_profiles.pilot.title') }}</b>
    <div class="result-profil-subtitle">
      <b>{{ $t('candidate_profiles.pilot.subtitle') }}</b>
    </div>
    <div class="result-profil-text">
        <span>{{$t('candidate_profiles.pilot.text1')}}</span>
        <span class="result-profil-highlight-word">{{$t('candidate_profiles.pilot.text2')}}</span>
        <span>{{$t('candidate_profiles.pilot.text3')}}</span>
        <span class="result-profil-highlight-word">{{$t('candidate_profiles.pilot.text4')}}</span>
        <span>{{$t('candidate_profiles.pilot.text5')}}</span>
        <span class="result-profil-highlight-word">{{$t('candidate_profiles.pilot.text6')}}</span>
        <span>{{$t('candidate_profiles.pilot.text7')}}</span>
    </div>
  </div>  
  <p class="result-profil-top3">
        <span>
          <b>{{ $t('candidate_profiles.discover3') }}</b>
        </span>
      </p>
  <div class="results-module-container">
    <gdss-feedback position="1" :top10="grades.gdss_grade === 1" />
    <adpt-feedback position="2" :top10="grades.adpt_grade === 1" />
    <rdpb-feedback position="3" :top10="grades.rdpb_grade === 1" />
  </div>
</template>

<script>
import RdpbFeedback from '@/views/game/results/feedback_rdpb.vue';
import GdssFeedback from '@/views/game/results/feedback_gdss.vue';
import AdptFeedback from '@/views/game/results/feedback_adpt.vue';

export default {
  components: {
    RdpbFeedback,
    GdssFeedback,
    AdptFeedback
  },
  props: {
    grades: {
      type: Object,
      required: true
    }
  },
};
</script>
